export default __webpack_public_path__ + "static/media/placeholder_illustration.5c2c2a36.png";